export const baseURL = "https://admin.shoppixa.com/";
export const secretKey = "$5TIvw5cpc0";
export const projectName = "Shoppixa";
